
import Vue from 'vue'
export default Vue.extend({
    name: 'MediaCard',
    props: {
        image: String,
    }
})
